var map = {
	"./apple/geoProvider": 560,
	"./browser/geoProvider": 561,
	"./node/geoProvider": 562,
	"./sony/trilithium/geoProvider": 563
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;


//////////////////
// WEBPACK FOOTER
// ./src/platforms ^\.\/.*\/geoProvider$
// module id = 559
// module chunks = 0